import {
  PanelLayout,
  OEText,
  maxHeight,
} from '@openeducation/oe-rn-components';
import { selectedLiveClassFeedbackAtom } from '@openeducation/oe-rn-jotai-atoms';
import type { LiveClassPendingFeedback } from '@openeducation/oe-rn-shared-types';
import { styled } from '@openeducation/oe-rn-themes';
import { useAtomValue } from 'jotai';
import * as React from 'react';
import { FlatList } from 'react-native';

import { TestId } from '../../constants/test-id';
import PCPendingFeedbackListItem from '../pc-pending-feedback-list-item/pc-pending-feedback-list-item';

export interface PCPendingFeedbackListProps {
  pendingFeedbacks?: LiveClassPendingFeedback[];
  onSelectedFeedbackChange: (feedback: LiveClassPendingFeedback) => void;
  isFeedbackSelected?: boolean;
}

export const PCPendingFeedbackList = ({
  pendingFeedbacks,
  onSelectedFeedbackChange,
  isFeedbackSelected,
}: PCPendingFeedbackListProps) => {
  const selectedLiveClassFeedback = useAtomValue(selectedLiveClassFeedbackAtom);

  const renderItem = ({ item }: { item: LiveClassPendingFeedback }) => {
    return (
      <PCPendingFeedbackListItem
        feedback={item}
        onSelectFeedback={() => onSelectedFeedbackChange(item)}
        isSelected={item === selectedLiveClassFeedback}
      />
    );
  };

  return (
    <PanelLayout width={300} padding={24} style={maxHeight(700)}>
      <Title>Pending feedback</Title>
      {isFeedbackSelected && (
        <TriangleLeft
          size={17}
          testID={TestId.PC_PENDING_FEEDBACK_LIST_SELECTED}
        />
      )}
      <FlatList
        testID={TestId.PC_PENDING_FEEDBACK_LIST}
        data={pendingFeedbacks}
        renderItem={renderItem}
        keyExtractor={({ attendanceId, classroomId, teacherId, studentId }) =>
          `${attendanceId}-${classroomId}-${teacherId}-${studentId}`
        }
        bounces={false}
      />
    </PanelLayout>
  );
};

const Title = styled(OEText)`
  color: ${({ theme }) => theme.color.dark3};
  padding-bottom: 16px;
  border-bottom-width: 1px;
  border-bottom-color: ${({ theme }) => theme.color.border};
  text-transform: uppercase;
  margin-bottom: 24px;
`;

type TriangleLeftType = {
  size: number;
};

const TriangleLeft = styled.View<TriangleLeftType>`
  position: absolute;
  top: 100px;
  left: ${({ size }) => -size}px;
  border-top-width: ${({ size }) => size}px;
  border-right-width: ${({ size }) => size}px;
  border-bottom-width: ${({ size }) => size}px;
  border-left-width: 0px;
  border-top-color: transparent;
  border-right-color: ${({ theme }) => theme.color.white};
  border-bottom-color: transparent;
  border-left-color: transparent;
`;
